module.exports = __webpack_public_path__ + "img/icon-plus.9d536120.svg";